import React, { useState, forwardRef, useImperativeHandle } from "react";
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import TextEditor from "../Frequents/TextEditor.js";
import API from "../../actions";

const NewNewsletter = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [newsletterId, setNewsletterId] = useState("");
    const [newsletterName, setNewsletterName] = useState("");
    const [newsletterDescription, setNewsletterDescription] = useState("");

    const handleClose = () => {
        setOpen(false);
        setNewsletterId("");
        setNewsletterName("");
        setNewsletterDescription("");
    };

    const handleSave = async () => {
        handleClose();
        if (props.new) await API.addNewsletter({ subject: newsletterName, message: newsletterDescription });
        else await API.setNewsletter({ id: newsletterId, subject: newsletterName, message: newsletterDescription });
        props.update();
    };

    const handleDelete = async () => {
        handleClose();
        await API.deleteNewsletter(newsletterId);
        props.update();
    };

    useImperativeHandle(ref, () => ({
        editNewsletter(id, name, desc) {
            setNewsletterId(id);
            setNewsletterName(name);
            setNewsletterDescription(desc);
            setOpen(true);
        }
    }));

    return (
        <div>
            {props.new ? (
                <Button
                    onClick={() => setOpen(true)}
                    style={{ backgroundColor: "#343434", color: "#fff", float: "right" }}
                    variant="contained"
                    startIcon={<AddCircleIcon />}>
                    Ny skabelon
                </Button>
            ) : null}
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="lg">
                {props.new ? (
                    <DialogTitle id="form-dialog-title">Nyt Nyhedsbrev</DialogTitle>
                ) : (
                    <DialogTitle id="form-dialog-title">Rediger Nyhedsbrev</DialogTitle>
                )}
                <DialogContent>
                    <DialogContentText>
                        Det oprettede nyhedsbrev kan sendes til alle klienter, der har givet samtykke til at modtage
                        nyhedsbreve.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="topic"
                        label="Emnefelt"
                        type="text"
                        fullWidth
                        value={newsletterName}
                        onChange={event => setNewsletterName(event.target.value)}
                    />
                    <TextEditor value={newsletterDescription} onChange={setNewsletterDescription} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Luk
                    </Button>
                    {props.new ? (
                        <Button onClick={handleSave} color="primary">
                            Opret
                        </Button>
                    ) : (
                        <Button onClick={handleSave} color="primary">
                            Gem
                        </Button>
                    )}
                    {props.new ? (
                        <></>
                    ) : (
                        <Button onClick={handleDelete} color="secondary">
                            Slet
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
});
export default NewNewsletter;
